<template>
    <div>
        <nav-top class="nav_top" id="nav_top"></nav-top>
        <div id="sign-content">
            <router-view></router-view>
        </div>
        <BottomBar></BottomBar>
    </div>
</template>
<script>
    import NavTop from '@/views/NavTop.vue'
    import BottomBar from '@/views/BottomBar.vue'

    export default {
        name: 'home',
        data() {
            return {
                // tableHeight: document.body.clientHeight - 70,
                // screenHeight:window.innerHeight,
            }
        },
        created() {
        },
        mounted() {
            const that = this
            window.onresize = () => {
                return (() => {
                    window.screenHeight = window.innerHeight
                    this.screenHeight = window.screenHeight;
                })()
            }

            var add_dome = document.getElementById('nav_top')
            var add_dome_s_s = document.getElementById('nav_top').getElementsByTagName('div')[5]
                add_dome.style.borderBottom='0'
            add_dome_s_s.style.borderBottom='0'
            var add_dome_s = document.getElementById('app')
            add_dome_s.addEventListener("scroll",this.handleScroll);
        },
        methods:{
            handleScroll(){
                var top = document.querySelector('#app').scrollTop
                var add_dome = document.getElementById('nav_top')
                if(top>0){
                    add_dome.style.borderBottom='1px #bcc7c1 solid'
                    add_dome.style.background='#fff'
                }else {
                    add_dome.style.borderBottom='0'
                    add_dome.style.background='none'
                }
            }
        },
        watch: {
            screenHeight(val) {
                this.screenHeight = val
                this.tableHeight = this.screenHeight - 80
            }
        },
        components: {
            NavTop,BottomBar
        }
    }
</script>

<style lang="scss">
    .nav_top{
        position: fixed;
        width: 100%;
        z-index: 100;
        /*background: #ffffff;*/
    }
    #sign-content {
        background-color: #ffffff;
        padding-top: 70px;
    }
    #sign-content >div{
        background: #ffffff;
    }

    .sign-page-content {
        width: 1180px;
        margin: 0 auto;
        margin-top: 8px;
        overflow: auto;
    }
</style>
